import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const {
  endpoints: {
    account: { logout: url },
  },
} = config

const logout = () => axios.get(url, { headers: getHeaders(true) })

export default logout
